"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Accordion = function Accordion(props) {
  var accordions = props.values.map(function (element, index) {
    var arrow;

    if (element.open) {
      arrow = "arrow-up";
    } else {
      arrow = "arrow-down";
    }

    ;
    var accordionClasses = (0, _classnames["default"])("content", props.className, {
      "open": element.open
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: accordionClasses,
      key: "accordions-element-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "title-content",
      onClick: function onClick() {
        props.handleClick(element.value);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-arrow-head",
      className: arrow
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "title"
    }, element.title)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-content"
    }, element.text));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "accordion-component"
  }, accordions);
};

Accordion.propTypes = {
  values: _propTypes["default"].arrayOf(_propTypes["default"].object),
  className: _propTypes["default"].string,
  handleClick: _propTypes["default"].func
};
Accordion.defaultProps = {
  values: [],
  className: "",
  handleClick: function handleClick() {}
};
var _default = Accordion;
exports["default"] = _default;